import React from "react";
import DocumentsForm from "../../Documents";

const Documents = () => {
  return <DocumentsForm />;
};

export default Documents;